import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unsnoozeAlert } from "../../../api/alertsApi";

export const useUnsnoozeAlert = () => {
  const queryClient = useQueryClient();
  return useMutation((alertId: string) => unsnoozeAlert(alertId), {
    // Invalidating the ["alerts"] prefix refreshes the main list (the alert reappears there),
    // every useDashboardAlerts() entry, and the Snoozed list itself (react-query v4 matches
    // invalidateQueries by key prefix) - same reasoning as useDismissAlert/useSnoozeAlert.
    onSuccess: () => queryClient.invalidateQueries(["alerts"]),
  });
};
